const TEAM_LOGOS = {
  'al hilal': 'https://r2.thesportsdb.com/images/media/team/badge/w0b80d1661656916.png',
  'al nassr': 'https://r2.thesportsdb.com/images/media/team/badge/84yvqi1748524565.png',
  'al nasser': 'https://r2.thesportsdb.com/images/media/team/badge/84yvqi1748524565.png',
  'al ahli': 'https://r2.thesportsdb.com/images/media/team/badge/1bbtgb1755192301.png',
  'al ittihad': 'https://r2.thesportsdb.com/images/media/team/badge/8n1t1j1755192418.png',
  'al shabab': 'https://r2.thesportsdb.com/images/media/team/badge/zbums21755192520.png',
  'al taawoun': 'https://r2.thesportsdb.com/images/media/team/badge/rlsmp91646835052.png',
  'al taawon': 'https://r2.thesportsdb.com/images/media/team/badge/rlsmp91646835052.png',
  'al fateh': 'https://r2.thesportsdb.com/images/media/team/badge/a5cjf41662659789.png',
  'al fayha': 'https://r2.thesportsdb.com/images/media/team/badge/jl3spp1677530565.png',
  'al feiha': 'https://r2.thesportsdb.com/images/media/team/badge/jl3spp1677530565.png',
  'al ettifaq': 'https://r2.thesportsdb.com/images/media/team/badge/m272h51694761970.png',
  'al riyadh': 'https://r2.thesportsdb.com/images/media/team/badge/i4o0zy1755193321.png',
  'al khaleej': 'https://r2.thesportsdb.com/images/media/team/badge/mvf6ga1755192630.png',
  'al qadsiah': 'https://r2.thesportsdb.com/images/media/team/badge/ok63wb1719134839.png',
  'damac': 'https://r2.thesportsdb.com/images/media/team/badge/z2l4w31677530963.png',
  'dhamk': 'https://r2.thesportsdb.com/images/media/team/badge/z2l4w31677530963.png',
  'al hazem': 'https://r2.thesportsdb.com/images/media/team/badge/3uy27p1635871755.png',
  'al okhdood': 'https://r2.thesportsdb.com/images/media/team/badge/ub1l7h1755193155.png',
  'al kholood': 'https://r2.thesportsdb.com/images/media/team/badge/vv44v01755192851.png',
  'neom': 'https://r2.thesportsdb.com/images/media/team/badge/4luwe11737685220.png',
  'al najma': 'https://r2.thesportsdb.com/images/media/team/badge/o65fn01737686968.png',
  'al najmah': 'https://r2.thesportsdb.com/images/media/team/badge/o65fn01737686968.png',
  'abha': 'https://r2.thesportsdb.com/images/media/team/badge/e00pwe1677530619.png',
  'al faisaly': 'https://r2.thesportsdb.com/images/media/team/badge/a81pz21646835057.png',
  'al diriyah': 'https://r2.thesportsdb.com/images/media/team/badge/0m7ub31782452735.png',
  'al diriyah fc': 'https://r2.thesportsdb.com/images/media/team/badge/0m7ub31782452735.png',
};

function normalize(name) {
  return (name || '').toLowerCase()
    .replace(/[-_]/g, ' ')
    .replace(/^al\s+/, 'al ')
    .replace(/\s+/g, ' ')
    .trim();
}

function findLogo(teamName) {
  const n = normalize(teamName);
  if (TEAM_LOGOS[n]) return TEAM_LOGOS[n];
  for (const [key, url] of Object.entries(TEAM_LOGOS)) {
    if (n.includes(key) || key.includes(n)) return url;
  }
  return null;
}

export function TeamLogo({ name, badgeUrl, size = 28, className = '' }) {
  const logo = badgeUrl || findLogo(name);
  if (logo) {
    return <img src={logo} alt={name} className={`rounded object-contain ${className}`} style={{ width: size, height: size }} />;
  }
  const initial = (name || '?')[0].toUpperCase();
  return (
    <div className={`rounded bg-gray-100 flex items-center justify-center text-gray-500 font-bold ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.4 }}>
      {initial}
    </div>
  );
}
